<template>
    <v-app-bar fixed app height="65" style="width: auto;">
        <v-btn fab small @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : $emit('input', !value)">
            <v-icon v-if="value">
                mdi-view-quilt
            </v-icon>

            <v-icon v-else>
                mdi-dots-vertical
            </v-icon>
        </v-btn>

        <v-toolbar-title class="hidden-sm-and-down" v-text="$route.name" />

        <v-spacer />
</v-app-bar>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'; // Utilities


    export default {
        name: 'DashboardCoreAppBar',

        /* >>> *************************************************************** / /* Components */
        components: {}, // eof components{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Props */
        props: {
            value: {
                type: Boolean,
                default: false
            }
        },
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Data */
        data: () => ({

        }), // eof data()
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapState(['drawer'])

        }, // eof computed{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapMutations({
                setDrawer: 'SET_DRAWER'
            })

        } // eof methods()
        /* <<< ****************************************************************/
    };
</script>
